
    <ng-container>
        <div class="image-upload">
            <ngx-dropzone class="dropzone" expandable="true" (change)="startUpload($event)" accept="*">
                <ngx-dropzone-label *ngIf="mediaFilesToUpload.length == 0">Upload image</ngx-dropzone-label>
                <ngx-dropzone-label *ngIf="mediaFilesToUpload.length > 0">
                    Uploading {{mediaFilesToUpload.length}} media<br>
                    {{mediaFilesToUpload[0].percentage}}mb / {{mediaFilesToUpload[0].totalSize}}mb<br>
                </ngx-dropzone-label>
            </ngx-dropzone>
        </div>

        <div class="images">
            
            <div class="image mobile-hide" *ngFor="let media of item.media;let i = index;">
                
                <ng-container *ngIf="(getType(media) | async) === MediaType.IMAGE">
                    <div (click)="openImageDialogMobile(media)" class="requiredImage" [ngStyle]="{'background-image': getImageUrl(media)}"></div>
                    <div class="row">
                        <button (click)="editImage(media, i, false)" mat-button>Edit</button>
                        <button (dblclick)="removeMedia(media, i)" mat-button>Remove</button>
                    </div>
                    
                    
                    <div class="row">
                        <button (click)="download(media)" mat-button><mat-icon style="top:4px;">download</mat-icon></button>
                        <a [href]="getMediaSrc(media)" target="_blank" mat-button><mat-icon style="top:9px;">open_in_new</mat-icon></a>
                        <button (click)="editImage(media, i, true)" mat-button><mat-icon style="top:4px;">visibility</mat-icon></button>
                    </div>


                    <div class="row">
                        <button (click)="shiftMediaLeft(i)" mat-button><mat-icon>chevron_left</mat-icon></button>
                        <button (click)="shiftMediaRight(i)" mat-button><mat-icon>chevron_right</mat-icon></button>
                    </div>
                </ng-container>

                <ng-container *ngIf="(getType(media) | async) === MediaType.VIDEO">
                    <div (click)="openImageDialogMobile(media)" class="requiredImage" [ngStyle]="{'background-image': getImageUrl(media)}"></div>
                    <div class="row">
                        <button (click)="editVideo(media, i, false)" mat-button>Edit</button>
                        <button (dblclick)="removeMedia(media, i)" mat-button>Remove</button>
                    </div>
                    
                    
                    <div class="row">
                        <button (click)="download(media)" mat-button><mat-icon style="top:4px;">download</mat-icon></button>
                        <a [href]="getMediaSrc(media)" target="_blank" mat-button><mat-icon style="top:9px;">open_in_new</mat-icon></a>
                        <button (click)="editVideo(media, i, true)" mat-button><mat-icon style="top:4px;">visibility</mat-icon></button>
                    </div>


                    <div class="row">
                        <button (click)="shiftMediaLeft(i)" mat-button><mat-icon>chevron_left</mat-icon></button>
                        <button (click)="shiftMediaRight(i)" mat-button><mat-icon>chevron_right</mat-icon></button>
                    </div>
                </ng-container>

                <ng-container *ngIf="(getType(media) | async) === MediaType.NONE">
                    <div class="requiredImage mediaNone"></div>
                    <div class="row">
                        <a [href]="getMediaSrc(media)" target="_blank" mat-button>Open</a>
                        <button (dblclick)="removeMedia(media, i)" mat-button>Remove</button>
                    </div>
                    
                    
                    <div class="row">
                        <button (click)="download(media)" mat-button><mat-icon style="top:4px;">download</mat-icon></button>
                        <a [href]="getMediaSrc(media)" target="_blank" mat-button><mat-icon style="top:9px;">open_in_new</mat-icon></a>
                    </div>


                    <div class="row">
                        <button (click)="shiftMediaLeft(i)" mat-button><mat-icon>chevron_left</mat-icon></button>
                        <button (click)="shiftMediaRight(i)" mat-button><mat-icon>chevron_right</mat-icon></button>
                    </div>
                </ng-container>
            </div>

            <div class="mobile-images desktop-hide" *ngFor="let media of item.media;let i = index;">
                <img (click)="editImage(media, i, false)" [src]="getImageUrl2(media)">
            </div>
        </div>
    </ng-container>



